import RoleErrorComponent from './RoleErrorComponent';

export default RoleErrorComponent;
